export const USE_COMPANY_KEY = '/api/company';
